export const filterByTranslation = <
  T extends {
    translations: {
      title: string;
      shortDescription?: string | null;
      description?: string;
    }[];
    id: string | number;
  },
>(
  items: T[] | undefined,
  search: string
): T[] => {
  if (!items) return [];

  const q = search.trim().toLowerCase();
  if (!q) return items;

  return items.filter(
    (item) =>
      item.translations.some(
        (translation) =>
          translation.title.toLowerCase().includes(q) ||
          (translation.shortDescription?.toLowerCase().includes(q) ?? false) ||
          (translation.description?.toLowerCase().includes(q) ?? false)
      ) || String(item.id).includes(q)
  );
};

export const filterMedia = <
  T extends { fileName: string; id: string | number },
>(
  items: T[] | undefined,
  search: string
): T[] => {
  if (!items) return [];
  const q = search.trim().toLowerCase();

  if (!q) return items;

  return items.filter(
    (item) =>
      item.fileName.toLowerCase().includes(q) || String(item.id).includes(q)
  );
};
